import { FC } from 'react'
import type { IconProps } from '../types'

// prettier-ignore
const NavigationLeftIcon: FC<IconProps> = ({ size = 24, color = '#fff' }) => (
  <svg xmlns='http://www.w3.org/2000/svg' width={size} height={size} fill='none' viewBox='0 0 24 24'>
    <path fill={color} fillRule='evenodd'
          d='M15.7 5.3a1 1 0 0 1 0 1.4L10.42 12l5.3 5.3a1 1 0 0 1-1.42 1.4l-6-6a1 1 0 0 1 0-1.4l6-6a1 1 0 0 1 1.42 0Z'
          clipRule='evenodd' />
  </svg>
)

export default NavigationLeftIcon
